module.exports = __webpack_public_path__ + "static/media/FBSE.8af42059.pdf";